<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<h4 class="text-center" mat-dialog-title>
  <span i18n="@@caution">Attention</span> - <span i18n="@@equinePayment">Equine payment</span>
</h4>

<div mat-dialog-content>
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center">
    <p i18n="@@equinePaymentInfo">
      The removal of this equine will be the subject of a payment. You can choose to pay for your pickup directly from
      Provalt by choosing "Settlement" below or you can choose to pay your pick up at of ANGEE. The payment certificate
      IFCE-ANGEE must therefore be provided at the collection of the animal.
    </p>
  </div>
</div>

<div mat-dialog-actions>
  <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3">
    <button class="btn btn-secondary btn-block" (click)="close(false)" i18n="@@payment">Payment</button>
  </div>

  <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3">
    <button class="btn btn-primary btn-block" (click)="close(true)" i18n="@@angee">IFCE-ANGEE</button>
  </div>
</div>

